import { ChakraProvider } from '@chakra-ui/react'
import { RecoilRoot } from 'recoil'

import * as React from 'react'

import { LayoutContext, layoutInitialState, layoutReducer } from '../context/LayoutContext'
import { theme } from '../styles/theme'
import LayoutContent from './LayoutContent'

// function DebugObserver(): React.Node {
//   const snapshot = useRecoilSnapshot()
//   React.useEffect(() => {
//     console.debug('The following atoms were modified:')
//     for (const node of snapshot.getNodes_UNSTABLE({ isModified: true })) {
//       console.debug(node.key, snapshot.getLoadable(node))
//     }
//   }, [snapshot])

//   return null
// }

type Props = {
  children: React.ReactNode
}

const Layout: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = React.useReducer(layoutReducer, layoutInitialState)
  return (
    <RecoilRoot>
      <ChakraProvider resetCSS={true} theme={theme}>
        <LayoutContext.Provider value={{ state, dispatch }}>
          <LayoutContent>{children}</LayoutContent>
        </LayoutContext.Provider>
      </ChakraProvider>
    </RecoilRoot>
  )
}

export default Layout
